var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillingStriked = function SvgBillingStriked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    clipPath: "url(#billing-striked_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "m4.666 13.333-2 1.334V1.333h10.667v13.334l-2-1.334-1.667 1.334-1.667-1.334-1.666 1.334z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M9.948 10.02a2.4 2.4 0 0 1-.923.185 2.66 2.66 0 0 1-2.538-2.769 2.66 2.66 0 0 1 2.538-2.77c.257.002.512.043.757.12M5.334 6.513h2.77M5.334 8.36h2.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F5F6",
    strokeWidth: 4,
    d: "M15.707 4.688 1 11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 1.33,
    d: "M14.98 5 1 11.046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "billing-striked_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgBillingStriked;